.grid {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 17rem), 1fr));
}

/* Reveal wraps each card, so the card itself must fill its wrapper. */
.grid > * {
  height: 100%;
}

.group {
  height: 100%;
  padding: 1.5rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  background: var(--bg-elev);
  transition: border-color 200ms ease, transform 200ms ease;
}

.group:hover {
  border-color: var(--border-strong);
  transform: translateY(-2px);
}

.groupName {
  font-size: var(--step-0);
  font-weight: 600;
  letter-spacing: -0.01em;
  margin-bottom: 1.1rem;
  padding-bottom: 0.85rem;
  border-bottom: 1px solid var(--border);
}

.tags {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.tag {
  padding: 0.35rem 0.7rem;
  border-radius: var(--radius-pill);
  border: 1px solid var(--border);
  background: var(--bg-inset);
  color: var(--text-dim);
  font-size: 0.8rem;
  font-weight: 500;
  white-space: nowrap;
}
